angular.module('bmsApp.settings').controller('RoomTypeSaveCtrl',
	function ($scope, $log, MMRoomTypeSvc, MMCleaningInstructionSvc, notify, $q) {

		$scope.settingData = {};
		$scope.loading = true;
		$scope.processing = false;

		var promises = {
			rooms: MMRoomTypeSvc.index(),
			instructions: MMCleaningInstructionSvc.index()
		};

		$q.all(promises).then(function (responses) {
			$scope.rooms = responses.rooms.data.room_type_collection;
			$scope.instructions = responses.instructions.data.cleaning_instruction_collection;
			$scope.loading = false;
		});


		$scope.submit = function (rooms) {
			var promise;
			promise = MMRoomTypeSvc.save(rooms);
			$scope.processing = true;
			promise.then(function (response) {
				notify({
					message: 'Room types saved'
				});
				$scope.rooms = response.data.room_type_collection;
				$scope.processing = false;
			}, function (error) {
				$scope.errors = error;
				$scope.processing = false;
			});

		};

		$scope.addRoom = function(){
			$scope.rooms.push({});
		};

		$scope.removeRoom = function(room){
			room.deleted = true;
		};

		$scope.reinstateRoom = function(room){
			room.deleted = false;
		};


	});



